import React, { useState, useRef } from "react";
import "./TemplateCard.css"; // Import the CSS file for styling
import placeholder from "../assets/focusmap-placeholder.png";
import { FaPlus } from "react-icons/fa"; // Import the plus icon
import { FaEllipsisV } from "react-icons/fa";
import { MdAddLink, MdLink, MdWorkspacePremium } from "react-icons/md";
import { Flow, SystemTemplate } from "../types/types";
import nabc from "../assets/images/nabc.png";
import pws from "../assets/images/pws.png";
import wbs from "../assets/images/wbs.png";
import sow from "../assets/images/sow.png";
import sbs from "../assets/images/sbs.png";
import spc from "../assets/images/scrum-process-clarity.png";
import { Template } from "../types/types";
import { useNavigate } from "react-router-dom";
import { deleteTemplate, loadMyTemplates } from "../storage/storageProxy";
import { useStore } from "../App/store";
import { formatTimestamp } from "../Helpers/Calculations";

interface TemplateCardProps {
  template: Template;
  templateImage?: string;
  handleTemplateClick: (id: string) => void;
  loadTemplates: () => void;
}

const TemplateCard: React.FC<TemplateCardProps> = ({
  template,
  templateImage,
  handleTemplateClick,
  loadTemplates,
}) => {
  const imageMap: Record<string, string> = {
    nabc: nabc,
    pws: pws,
    wbs: wbs,
    sow: sow,
    sbs: sbs,
    spc: spc,
  };

  const [showMenu, setShowMenu] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [showRenameConfirmModal, setShowRenameConfirmModal] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const handleMenuClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLDivElement>,
    action: string
  ) => {
    event.stopPropagation();
    if (action === "rename") {
      setShowRenameConfirmModal(true);
    } else if (action === "delete") {
      setShowDeleteConfirmModal(true);
    } else {
      alert("Not yet available");
    }
    setShowMenu(false);
  };

  const handleConfirmDelete = async (event: React.MouseEvent) => {
    try {
      await deleteTemplate(template.id, useStore.getState().useLocalStorage);
    } catch (error) {
      console.error("Error deleting template: ", error);
      alert("Failed to delete template");
    }
    event.stopPropagation();
    setShowDeleteConfirmModal(false);
    loadTemplates();
  };

  const handleCancelDelete = async (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowDeleteConfirmModal(false);
  };

  // const handleConfirmRename = async (
  //   event: React.MouseEvent,
  //   renamed: string
  // ) => {
  //   event.stopPropagation();
  //   try {
  //     await updateDoc(doc(db, "flows", flow.id), { name: renamed });
  //     setFlowName(renamed);
  //   } catch (error) {
  //     console.error("Error renaming document: ", error);
  //     alert("Failed to rename document");
  //   }
  //   setShowRenameConfirmModal(false);
  // };

  const handleCancelRename = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowRenameConfirmModal(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setShowMenu(false);
    }
  };

  return (
    <div
      key={template.id}
      className="template-card"
      onClick={() => handleTemplateClick(template.id)}
    >
      <div className="template-card-image-container">
        <img
          src={templateImage || imageMap[template.logo] || placeholder}
          alt="Map Placeholder"
          className="template-card-image"
        />
      </div>
      <div className="template-card-details">
        <div className="template-headline">{template.name}</div>
        <div className="template-description">{template.description}</div>
        <div className="template-date">
          Created: {formatTimestamp(template.timestamp)}
        </div>
        <div
          className="template-card-menu"
          onClick={handleMenuClick}
          ref={menuRef}
        >
          <FaEllipsisV />
          {showMenu && (
            <div className="popup-menu">
              {/* <div
              className="popup-menu-item"
              onClick={(event) => handleMenuItemClick(event, "rename")}
            >
              Rename
            </div> */}
              <div
                className="popup-menu-item"
                onClick={(event) => handleMenuItemClick(event, "delete")}
              >
                Delete
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
